/**
 * @desc 查询预告公告文档
 */
import {
  PageArticleEntity,
  ArticleQuery
} from '@eastcoal/api/elasticsearch/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type SearchArticleParameter = ArticleQuery

const method = 'GET'
const url = '/elasticsearch/mall/article/search'

export const searchArticleApi = (
  params?: SearchArticleParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageArticleEntity>({
    method,
    url,
    params,
    ...config
  })
}

searchArticleApi.method = method
searchArticleApi.url = url
